import React from 'react';
import { Box, IconButton } from '@mui/material';
import '../Running.css';
import { Filter, FilterPrefs, FilterDrawer } from './Filter';
import { TBar, ABar } from './Widgets';
import { addCell, formatTime, formatShortName, getRunner, serverRequest, ParkrunRecord } from './Util';
import { GlobalContext } from '../context/GlobalContextProvider';
import MenuIcon from '@mui/icons-material/Menu';

interface ParkrunTableState {
    course: string;
    year: number;
}

interface ParkrunTableProps {
    records: Record<string, ParkrunRecord>;
    age_group: string;
    gender: string;
    mainOnly: boolean;
}

export class ParkrunTable extends React.Component<ParkrunTableProps, ParkrunTableState> {
    constructor(props: ParkrunTableProps) {
        super(props);
        this.state = { course: '', year: 0 }
        this.onSelectRace = this.onSelectRace.bind(this);
    }

    componentDidUpdate(prevProps: ParkrunTableProps) {
        if (prevProps.records !== this.props.records)
            this.setState( { course: '', year: 0} );
    }
    
    onSelectRace = (e: React.MouseEvent<HTMLElement>) => {
        const course = e.currentTarget.dataset.courseKey;
        const yearkey = e.currentTarget.dataset.yearKey;
        if (!course || !yearkey) return;
        const year = Number(yearkey);
        const deselect = this.state.course === course && this.state.year === year;
        if (deselect)
            this.setState( { course: '', year: 0} );
        else
            this.setState( { course: course, year: year} );
    }

    render_event(cells: JSX.Element[], course: string, year: number, elem: [number, string], eventrec: number) {
        if (elem !== undefined) {
            var perf = elem[0]
            var runner = getRunner(elem[1]);

            var sbstyle: React.CSSProperties  = perf === eventrec ? {'color': 'red'} : {};
            if (course === this.state.course && year === this.state.year) {
                sbstyle['backgroundColor'] = 'yellow';
            }

            cells.push(<td onClick={this.onSelectRace} data-course-key={course} data-year-key={year} style={sbstyle} className='pbcol'>
                            <b>{formatTime(perf, course)}</b><br/>{formatShortName(runner)}
                            </td>);
        } else
            cells.push(addCell(''));
    }

    static sortByCourse(a: string, b: string) {
        return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    }
    
    render() {
        // Finds all courses and all years and builds a direct access dict
        var pbdict: Record<string, [number, string]> = {};
        var courserec: Record<string, [number, string]> = {};
        var years: number[] = [];
        var totalfin: Record<string, number> = {}

        for (var key in this.props.records) {
            var pb = this.props.records[key]
            var year = pb['Year']
            var course = pb['Venue']
            var numfin = pb['Num']

            // Calculates all-time records
            if (courserec[course] === undefined || courserec[course][0] > pb['Time'])
                courserec[course] = [pb['Time'], pb['ID']]

            if (totalfin[course] === undefined)
                totalfin[course] = 0
            totalfin[course] += numfin

            if (years.indexOf(year) < 0)
                years.push(year)

            pbdict[year+","+course] = [pb['Time'], pb['ID']]
        }

        // Sorts events and years
        var courses: string[] = Object.keys(courserec);
        courses.sort(ParkrunTable.sortByCourse);
        years.sort().reverse();

        var minfin = (this.props.age_group !== "") ? 10 : 100;
        // console.log("Age group: " + "'" + this.props.age_group + "' => " + minfin)
        var rows: JSX.Element[] = [];
        for (course of courses) {
            if (this.props.mainOnly && totalfin[course] < minfin)
                continue;

            var cells: JSX.Element[] = [];     
            var bgcol = 'var(--table-header-color)';
            var title = course + " [" + totalfin[course] + "]"
            cells.push(<th className='sticky-col first-large-col' style={{backgroundColor: bgcol}}>{title}</th>);
            // All-time Records
            var elem = courserec[course]
            this.render_event(cells, course, 0, elem, elem[0])

            for (year of years) {
                elem = pbdict[year+","+course]
                this.render_event(cells, course, year, elem, courserec[course][0]);
            }
            rows.push(<tr>{cells}</tr>);
        }

        // Shows selected race or leaderboard (TBD)
        var selDetail = <></>
        var maxH = '100vh';

        // Header
        var head = <tr><th></th><th>{"ALL"}</th>{years.map((key, index) => { return <th>{key}</th> })}</tr>
        var table = <div className='wrapper' style={{'maxHeight': maxH}}>
                        <table className='bicolortable'><thead>{head}</thead><tbody className='link'>{rows}</tbody></table>
                    </div>
        
        return <div style={{padding: '16px'}}>{table}{selDetail}</div>
    }
}

interface ParkrunProps { }

interface ParkrunState {
    course: string;
    selRaceID: number;
    selRunnerID: string;
    records: Record<string, ParkrunRecord>;
    age_group: string,
    gender: string,
    mainOnly: boolean
}

export class Parkrun extends  React.Component<ParkrunProps, ParkrunState> {
    static contextType = GlobalContext;

    constructor(props: ParkrunProps) {
        super(props);

        this.state = {
            course: '',
            records: {},
            selRaceID: 0,
            selRunnerID: '',
            age_group: '',
            gender: '',
            mainOnly: true
        }
        this.loadParkrun = this.loadParkrun.bind(this);
    }

    componentDidMount() {
        this.loadParkrun(new Filter(0, 0, '', 'W', '', true, ''), true);
    }
    
    loadParkrun(filter: Filter, requery: boolean) {
        if (requery) {
            serverRequest("parkrunrecords?gender=" + filter.gender + "&age_group=" + filter.age_group)
            .then(res => {
                this.setState({records: res, selRaceID: 0, course: '', gender: filter.gender, age_group: filter.age_group, mainOnly: filter.mainOnly});
            });
        } else {
            this.setState({mainOnly: filter.mainOnly});
        }
    }

    static filter_prefs: FilterPrefs = {year: false, month: false,
        event: false, all_event: false, mainOnly: true,
        gender: true, all_gender: false, age_group: true, all_age_group: false, meeting: false };

    openMenu = () => {
        const ctx = this.context as React.ContextType<typeof GlobalContext>;
        ctx.setMenuOpen(!ctx.menuOpen);
    }

    render() {
        var filter = <FilterDrawer onChange={this.loadParkrun} prefs={Parkrun.filter_prefs} start_filter={new Filter(0, 0, '', 'W', '', this.state.mainOnly, '')} display_filter={true} />  
        
        var appbar = <div>
                <ABar position="top" >
                    <TBar>
                    <IconButton sx={{ color: 'var(--paper-color)'}} onClick={this.openMenu}>
                        <MenuIcon fontSize="large"></MenuIcon>
                    </IconButton>
                    <div className='largetext' >Parkrun Records</div>
                    <Box sx={{ flexGrow: 1}} />
                    {filter}
                    </TBar>
                </ABar>
            </div>

        var tables = <ParkrunTable records={this.state.records} age_group={this.state.age_group} gender={this.state.gender} mainOnly={this.state.mainOnly} />

        return <div>
            {appbar}
            <div>{tables}</div>
            </div>;
    }
}
